module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/warrior-profile-cover-b15724e545de02417550bcbbfeceb17d.jpg";